import axios from 'axios';
import { urlsServices } from '@/config/urls';

let httpUrl = `${urlsServices.GETWAY}api/template-documento`;
export const gerarHtmlDocumentoRegistroAtendimento = async (dados) => {
  return await axios.post(`${httpUrl}/registro-atendimento`, dados).then((response) => response);
};

export const gerarHtmlDocumentoPaciente = async (dados) => {
  return await axios.post(`${httpUrl}/paciente`, dados).then((response) => response);
};
